import React from 'react';
import { fetchConfig } from '@/hooks/fetch';
import CohortCountsLabelContainer from './CohortCountsLabelContainer';
import CohortCountsLabel from './CohortCountsLabel';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';
import Events from '../hooks/events';

const ClausesCounts = ({
  category,
  code,
  queryUUID,
  dictionaryCode,
  hideEntities,
}) => {
  const state = Selectors.useClausesCounts({
    category, code, queryUUID, dictionaryCode,
  });
  const toggleCounts = Events.useToggleClausesCounts(category, { code });
  Fetch.useFetchClausesCounts({
    category, code, queryUUID, dictionaryCode,
  }, state.readStatus, fetchConfig([queryUUID, dictionaryCode], () => state.allowCohortCounts));

  if (!state.allowCohortCounts) {
    return null;
  }

  return (
    <CohortCountsLabelContainer readStatus={state.readStatus} readErrors={state.readErrors}>
      <CohortCountsLabel
        color="grey"
        count={state.count}
        hideEntities={state.count === 0 || state.entities.length === 0 || hideEntities}
        message="cohort.counts.overall.total.title"
        onClick={() => toggleCounts({ queryUUID, dictionaryCode })}
        showCounts={state.showCounts}
        total={state.total}
      />
    </CohortCountsLabelContainer>
  );
};

export default ClausesCounts;
